module.exports = __webpack_public_path__ + "static/img/zgyl.63237b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zgyl.png
// module id = B8dk
// module chunks = 0